import { Lock } from 'lucide-react';

// Bloc "Configuration (par défaut)" unifié pour les onglets d'achat catégorie & mono.
// Affiche une table 3 colonnes [Catégorie/Sujet] [Groupe] [Mode] + une aide et une note
// sur ce qui reste modifiable après coup.
export default function CodeConfigBlock({
    targetLabel, targetPlaceholder, targetOptions,
    targetValue, onTargetChange,
    groupValue, onGroupChange,
    mode, onModeChange,
    modeDescriptions,
    durationOptions, durationValue, onDurationChange,
}) {
    const hasTarget   = !!targetLabel;
    const hasMode     = !!modeDescriptions;
    const hasDuration = Array.isArray(durationOptions) && durationOptions.length > 0;
    return (
        <div className="code-config-block">
            <div className="code-config-block__title">Configuration des codes <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(par défaut)</span></div>
            <div className="code-config-block__grid">
                {hasTarget && (
                    <label className="code-config-block__cell">
                        <span className="code-config-block__head">{targetLabel}</span>
                        <select value={targetValue} onChange={e => onTargetChange(e.target.value)}>
                            <option value="">{targetPlaceholder}</option>
                            {targetOptions.map(o => (
                                <option key={o.id ?? o.sous_sujet_id} value={o.id ?? o.sous_sujet_id}>
                                    {o.label ?? o.sous_sujet_label}
                                </option>
                            ))}
                        </select>
                    </label>
                )}
                <label className="code-config-block__cell">
                    <span className="code-config-block__head">Groupe / session</span>
                    <input type="text" value={groupValue} onChange={e => onGroupChange(e.target.value)}
                        placeholder="Ex : Promo 2026 (optionnel)" maxLength={100} />
                </label>
                {hasMode && (
                    <div className="code-config-block__cell">
                        <span className="code-config-block__head">Mode</span>
                        <div className="code-config-block__modes">
                            <button type="button"
                                className={mode === 'quiz' ? 'is-active' : ''}
                                onClick={() => onModeChange('quiz')}>Classique</button>
                            <button type="button"
                                className={mode === 'apprentissage' ? 'is-active' : ''}
                                onClick={() => onModeChange('apprentissage')}>Apprentissage</button>
                            <button type="button"
                                className={mode === 'sealed' ? 'is-active' : ''}
                                onClick={() => onModeChange('sealed')}>
                                <Lock size={11} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Scellé
                            </button>
                        </div>
                        <div className="code-config-block__mode-desc">
                            {modeDescriptions[mode]}
                        </div>
                    </div>
                )}
                {hasDuration && (
                    <div className="code-config-block__cell">
                        <span className="code-config-block__head">Durée</span>
                        <div className="code-config-block__modes">
                            {durationOptions.map(opt => (
                                <button key={opt.value} type="button"
                                    className={durationValue === opt.value ? 'is-active' : ''}
                                    onClick={() => onDurationChange(opt.value)}>
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <p className="code-config-block__note">
                {hasTarget && hasMode
                    ? <><strong>{targetLabel}</strong> et <strong>Mode</strong> restent modifiables tant que le code n'est pas utilisé &middot; <strong>Groupe</strong> modifiable à tout instant.</>
                    : <><strong>Groupe</strong> modifiable à tout instant.</>
                }
            </p>
        </div>
    );
}
